import { TListId } from '../../../../types/types';
import { IBoard } from '../../board/types';
import { EDashboardStatusListType } from '../../../../types/rest/IRestDashboard';

export const isListUsedInAutomation = (listId: TListId, board: IBoard): boolean => {
    let result: boolean = false;
    const listTypes: EDashboardStatusListType[] = Object.values(EDashboardStatusListType);
    listTypes.forEach((type) => {
        if (board.statusLists && board.statusLists[type] === listId) {
            result = true;
        }
    })
    return result;
}
